<template>
  <div class="body">
    <el-card class="box_card">
      <div class="header">
        <div class="header_title" @click="retrunBack"><i class="iconfont icontuichu" style="font-size:20px;"></i> &nbsp; 返回列表</div>
      </div>
      <div class="middle_table">
        <div class="patient">
          <span style="font-size:20px;">李朝阳</span> | 男 | 29岁
          <span class="patient_span" style="background: #31BFC5;margin-left:320px;" @click="applyItem"> 申请改项</span>
          <span class="patient_span" style="background: #23BD54;" @click="applyItem"> 申请退单</span>
        </div>
        <div class="patient_info">
          <div class="info_left">
            <div class="info_title">订单信息</div>
            <div class="info_content">订单编号：A1B01583948BA499C09280</div>
            <div class="info_content">下单时间：2021-03-01 21:26:06</div>
            <div class="info_content">开单医生：珍妮</div>
          </div>
          <div class="info_right">
            <div class="info_title">订单结算信息</div>
            <div class="info_content">订单金额：￥535.00</div>
            <div class="info_content">诊所实付：<span style="color:#F04562;font-weight: bold;"> ￥355.00</span></div>
            <div class="info_content">支付方式：钱包支付</div>
          </div>
        </div>
        <div class="order_remark">
          备注信息：暂无；
        </div>
        <div class="order_info">
          订单编号：A1B01583948BA499C09280
          <span class="info_tag"> 报告未出</span>
        </div>

        <div class="package_title">
          血常规 (五分类)、胃肠道疾病风险筛查套餐
        </div>

        <div class="report">
          <div class="report_info">
            <div class="orderContent_left">
              <!-- 条形码区域 -->
              <div class="order_left">
                <div class="left_tm">条<br />码<br />填<br />写</div>
                <div class="left_content">
                  <div class="code">
                    <div class="code_img">
                      <img src="@/assets/img/hg.png" style="width: 100%; height: 100%" />
                    </div>
                    <div class="code_right">
                      <div class="code_right_top">
                        <div class="code_inner_left">黄管</div>
                        <div class="code_inner_right"><el-input-number v-model="num1" size="medium" :min="minNum"></el-input-number></div>
                      </div>
                      <div class="code_right_bottom">
                        <el-input v-model="input" placeholder="A1B015"></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="code">
                    <div class="code_img">
                      <img src="@/assets/img/lg.png" style="width: 100%; height: 100%" />
                    </div>
                    <div class="code_right">
                      <div class="code_right_top">
                        <div class="code_inner_left">绿管</div>
                        <div class="code_inner_right"><el-input-number v-model="num1" size="medium"></el-input-number></div>
                      </div>
                      <div class="code_right_bottom">
                        <el-input v-model="input" placeholder="A1B015"></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="code">
                    <div class="code_img">
                      <img src="@/assets/img/languan.png" style="width: 100%; height: 100%" />
                    </div>
                    <div class="code_right">
                      <div class="code_right_top">
                        <div class="code_inner_left">蓝管</div>
                        <div class="code_inner_right"><el-input-number v-model="num1" size="medium"></el-input-number></div>
                      </div>
                      <div class="code_right_bottom">
                        <el-input v-model="input" placeholder="A1B015"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 科室检查区域 -->
              <div class="order_bottom" style="margin-top: 20px">
                <div class="bottom_tm">科<br />室<br />检<br />查</div>
                <div class="bottom_content">
                  <div class="department">
                    <div class="department_item">
                      <span class="item_name"> 身高：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input">
                        <template slot="append">Cm</template>
                      </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 体重：</span>
                      <el-input placeholder="公斤" v-model="input2" class="item_input">
                        <template slot="append">Kg</template>
                      </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 体重值：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input">
                        <template slot="append">Kg/M²</template>
                      </el-input>
                    </div>

                    <div class="department_item">
                      <span class="item_name"> 淋巴：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>

                    <div class="department_item">
                      <span class="item_name"> 甲状腺：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 其他：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                  </div>
                  <div class="department">
                    <div class="department_item">
                      <span class="item_name"> 体温：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input">
                        <template slot="append">℃</template>
                      </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 血压：</span>
                      <el-input placeholder="公斤" v-model="input2" class="item_input">
                        <template slot="append">Kg</template>
                      </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 心率：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input">
                        <template slot="append">次/分</template>
                      </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 心肺功能：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item" style="width:auto;">
                      <span class="item_name"> 发育及营养状态：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>

                    <div class="department_item" style="width:auto;">
                      <span class="item_name"> 肝、脾、双肾：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 腹部检查：</span>
                      <BaseSelect></BaseSelect>
<!--                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>-->
                    </div>
                  </div>
                  <div class="department">
                    <div class="department_item">
                      <span class="item_name"> 视力左眼：</span>
                      <el-input placeholder="" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 右眼：</span>
                      <el-input placeholder="" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item" style="width:auto;">
                      <span class="item_name"> 矫正视力左眼：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 右眼：</span>
                      <el-input placeholder="" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 耳听力：</span>
                      <el-input placeholder="" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item" style="width:auto;">
                      <span class="item_name"> 鼻及鼻窦疾病：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>

                    <div class="department_item">
                      <span class="item_name"> 咽喉：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                    <div class="department_item">
                      <span class="item_name"> 其他：</span>
                      <el-input placeholder="厘米" v-model="input2" class="item_input"> </el-input>
                    </div>
                  </div>
                  <div class="department_suggest">
                    <div class="suggest_top" style="margin-top:5px;">
                      <div class="top_title">
                        身形评估：
                      </div>
                      <div
                        :class="figureIindex === item.id ? 'top_tagactive' : 'top_tag'"
                        v-for="(item, index) in figureList"
                        :key="index"
                        @click="figureIindex = item.id"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                    <div class="suggest_top" style="margin-top:10px;">
                      <div class="top_title" style="width:120px;">
                        医生面检建议：
                      </div>
                      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"> </el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import BaseSelect from '@/pubilcComponents/BaseSelect/BaseSelect';
import { itemList } from './data';
export default {
  name: 'query',
  components: {BaseSelect},
  data() {
    return {
      textarea: '',
      minNum: 0,
      input2: null,
      input: null,
      num1: null,
      figureIindex: 1,
      figureList: [
        {
          id: 1,
          title: '标准'
        },
        {
          id: 2,
          title: '偏胖'
        },
        {
          id: 3,
          title: '肥胖'
        },
        {
          id: 4,
          title: '偏瘦'
        },
        {
          id: 5,
          title: '消瘦'
        }
      ],
      activeNames: '',
      tableData: []
    };
  },
  created() {},
  mounted() {
    var vm = this;
    vm.tableData = itemList;
  },
  methods: {
    applyItem() {
      this.$confirm('您是否确认进行申请退单操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      })
        .then(() => {
          this.$router.push('/login');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    retrunBack() {
      this.$router.push({ path: '/query', query: { name: '22222' } });
    }
  }
};
</script>

<style lang="scss" scoped>
$height: 540px;

.body {
  .iconpdf {
    color: #2d99d7;
    font-size: 30px;
    float: right;
    cursor: pointer;
  }
  .iconpdf:hover {
    color: #36b6ff;
    font-size: 30px;
    float: right;
  }
  width: 100%;
  height: 100%;
  // 去除卡片的padding
  ::v-deep .el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0px !important;
    border-radius: 30px 30px 0px 0px !important;
  }
  ::v-deep .el-card {
    border-radius: 30px 30px 0px 0px !important;
  }
  .box_card {
    height: 99%;
    // border: 1px solid rgb(53, 233, 8);
    margin-right: 30px;
    box-sizing: border-box;
    .header {
      width: 100%;
      height: 88px;
      background: #f0feff;
      border-radius: 30px 30px 0px 0px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      padding: 0 30px;
      .header_title {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2d99d7;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
      .header_title:hover {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #36b6ff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .middle_table {
    height: calc(100% - 90px);
    width: 100%;
    // border: 1px solid darkmagenta;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 10px 10px;
    .patient {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      width: 100%;
      .patient_span {
        margin-left: 20px;
        display: inline-block;
        width: 84px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        border-radius: 15px;
        color: #fff;
        cursor: pointer;
      }
      .patient_span:hover {
        box-shadow: 0 2px 6px 0 rgb(0, 174, 255);
      }
    }
    .patient_info {
      height: 100px;
      width: 100%;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      // border: 1px solid darkgoldenrod;
      margin-top: 15px;
      display: flex;
      justify-content: flex-start;
      .info_left,
      .info_right {
        width: 465px;
        height: 100%;
        .info_title {
          width: 1150px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-bottom: 10px;
        }
        .info_content {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          margin-bottom: 3px;
        }
      }
    }
    .order_remark {
      width: 100%;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      margin-bottom: 3px;
    }
    .order_info {
      width: 1150px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      margin-top: 20px;
      // border-bottom: 1px solid darkgoldenrod;
    }
    .info_tag {
      margin-left: 40px;
      display: inline-block;
      width: 84px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      color: #999999;
      border-radius: 15px;
      background: #ebebeb;
    }
    .package_title {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
    .report {
      margin-top: 5px;
      width: 100%;
      height: auto;
      // border: 1px solid palevioletred;
      box-sizing: border-box;
      // overflow-y: auto;
      // 设置表格左边距
      ::v-deep .el-table .cell {
        padding-left: 30px !important ;
      }
      .report_info {
        width: 100%;
        height: auto;
        // border: 1px solid #dddddd;
        box-sizing: border-box;
        // background: #f8f9fe;
        background: #fff;
        border-radius: 16px 16px 0px 0px;
        margin-bottom: 20px;
        .orderContent_left {
          // border: 1px solid red;
          width: 100%;
          height: auto;
          //科室检查样式
          .order_bottom {
            //height: $height;
            display: flex;
            justify-content: flex-start;
            border: 1px solid #f1e6e6;
            border-radius: 16px;
            box-sizing: border-box;
            .bottom_tm {
              width: 40px;
              //height: $height;
              background: #f0feff;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              font-size: 16px;
              color: #2d99d7;
              font-weight: 700;
              box-sizing: border-box;
              border-radius: 16px 0 0 16px;
            }
            .bottom_content {
              flex: 1;
              height: 100%;
              // border: 2px solid red;
              padding: 10px 20px;
              box-sizing: border-box;
              .department {
                margin: 10px 0;
                width: 100%;
                border-bottom: 1px dashed #b8b2b2;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;

                .department_item {
                  padding: 10px 0;
                  font-size: 14px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                  width: 250px;
                  // border: 1px solid pink;
                  margin-right: 45px;
                  .item_input {
                    width: 180px;
                  }
                  // input框后插样式调整
                  ::v-deep .el-input-group__append {
                    background-color: #fff !important;
                    padding: 0 10px !important;
                  }
                }
              }
              .department_suggest {
                width: 100%;
                margin-top: 10px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                .suggest_top {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  width: 100%;
                  .top_title {
                    display: flex;
                    // justify-content: flex-start;
                    align-items: center;
                  }
                  .top_tagactive {
                    width: 55px;
                    height: 26px;
                    font-size: 14px;
                    color: #409eff;
                    border: 1px solid #409eff;
                    border-radius: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    user-select: none;
                    margin-right: 15px;
                    cursor: pointer;
                  }
                  .top_tag {
                    width: 55px;
                    height: 26px;
                    font-size: 14px;
                    color: #999999;
                    border: 1px solid #999999;
                    border-radius: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    user-select: none;
                    margin-right: 15px;
                    cursor: pointer;
                  }
                }
              }
            }
          }

          // 条形码区域样式
          .order_left {
            display: flex;
            justify-content: flex-start;
            border: 1px solid #f1e6e6;
            border-radius: 16px;
            box-sizing: border-box;
            .left_tm {
              width: 40px;
              height: 140px;
              background: #f0feff;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              font-size: 16px;
              color: #2d99d7;
              font-weight: 700;
              box-sizing: border-box;
              border-radius: 16px 0 0 16px;
            }
            .left_content {
              flex: 1;
              height: 140px;
              // border: 1px solid rgb(118, 228, 15);
              padding: 10px;
              box-sizing: border-box;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              overflow-x: auto;
              .code {
                box-sizing: border-box;
                width: 380px;
                height: 100px;
                // border: 1px solid rgb(11, 136, 238);
                border-radius: 16px;
                display: flex;
                justify-content: flex-start;
                margin-right: 20px;
                .code_img {
                  width: 100px;
                  height: 100px;
                  border-radius: 16px;
                  overflow: hidden;
                }
                .code_right {
                  box-sizing: border-box;
                  width: 280px;
                  padding: 0 15px;
                  // border: 3px solid rgb(12, 241, 192);
                  .code_right_top {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                  .code_right_bottom {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
